import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/comics";

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20digital%20illustration%20with%20abstract%20flowing%20shapes%20in%20warm%20coral%20and%20golden%20amber%20gradients%2C%20soft%20ethereal%20atmosphere%20with%20floating%20light%20particles%2C%20painterly%20texture%2C%20dreamy%20and%20elegant%20backdrop%2C%20gentle%20color%20transitions%20from%20warm%20peach%20to%20deep%20burgundy%20with%20subtle%20golden%20accents%2C%20no%20text%2C%20clean%20artistic%20abstract%20background&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt="韩漫屋 - 韩国漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />

      <div className="relative z-10 h-full w-full px-4 md:px-6 flex items-center">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 leading-tight">
            发现最精彩的
            <br />
            韩国漫画世界
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-xl leading-relaxed">
            {siteConfig.description}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3 mt-6 md:mt-8">
            <Link
              to="/category/romance"
              className="px-7 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 rounded-full text-sm font-semibold border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}